require('./bootstrap');
window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
